/**
 * Utility della modifica manuale del risultato (Andrea 2026-09-15).
 */

export interface SogliaGol {
  punteggio_minimo: string;
  gol_assegnati: number;
}

/** Gol dai fantapunti con le soglie del regolamento: stessa regola del
 * calcolo (la soglia piu' alta raggiunta, altrimenti 0). */
export function golDaSoglie(punteggio: number, soglie: SogliaGol[]): number {
  const ordinate = [...soglie].sort(
    (a, b) => Number(b.punteggio_minimo) - Number(a.punteggio_minimo),
  );
  for (const s of ordinate) {
    if (punteggio >= Number(s.punteggio_minimo)) return s.gol_assegnati;
  }
  return 0;
}

/** "72,5" o "72.5" → 72.5; null se non e' un numero >= 0 con al piu' 2 decimali. */
export function leggiNumero(valore: string): number | null {
  const pulito = valore.trim().replace(",", ".");
  if (!/^\d{1,3}(\.\d{1,2})?$/.test(pulito)) return null;
  return Number(pulito);
}

/** "2" → 2; null se non e' un intero >= 0. */
export function leggiIntero(valore: string): number | null {
  const pulito = valore.trim();
  return /^\d{1,2}$/.test(pulito) ? Number(pulito) : null;
}

/** Fantapunti senza zeri inutili: 72.5, 66, 70.25. */
export function fmtPunti(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  return String(Math.round(Number(n) * 100) / 100);
}
